import React, {useContext} from 'react';
import AuthWrapper from '../Auth/AuthWrapper/AuthWrapper';
import { TextInput, Button } from '../../components';
import styles from './styles.module.css';
import { Row, Col } from 'react-flexbox-grid';
import profile from './profile1.jpg';
import Menu from './Menu'
import { useWindowSize, ResponsiveSize } from '../../utils/useWindowSize';
import { LanguageContext } from '../../context/Languages/LanguageProvider';

const Profile = () => {
  const { i18n } = useContext(LanguageContext);
  return (
    <AuthWrapper>
      <div className={styles.profile}>
       <Menu />
        <Row>
          <Col lg={4} xs={4}></Col>
          <Col lg={6} xs={12}>
            <div className={styles.header}>
              <h3>{i18n.changePersonalInfo}</h3>
            </div>
          </Col>
        </Row>
        <Row>
        {(useWindowSize().width > ResponsiveSize.MD + 1) && (
          <Col lg={4} xs={12}>
            <div className={styles.leftSide}>
              <div className={styles.profileImg}>
                <img src={profile} width={"100%"} alt="profileImg" />
              </div>
              <div className={styles.profileInfo}>
                <div className={styles.userName}>
                  <h3>John Doe</h3>
                  <p>Since 2019</p>
                </div>
                <div className={styles.otherInfo}>
                  <div className={styles.info}>
                    <label>{i18n.emailAddress}:</label>
                    <p title={"johndoe12345@mail.com"}>johndoe12345@mail.com</p>
                  </div>
                  <div className={styles.info}>
                    <label>{i18n.city}:</label>
                    <p>London</p>
                  </div>
                  <div className={styles.info}>
                    <label>{i18n.country}:</label>
                    <p>United Kingdom</p>
                  </div>
                  <div className={styles.info}>
                    <label>{i18n.phone}:</label>
                    <p>+90 000 000 000</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        )}
          <Col lg={6} xs={12}>
            <div className={styles.rightSide}>

              <label>{i18n.yourName}</label>
              <TextInput type={'text'} placeholder={i18n.yourName} />
              <label>{i18n.emailAddress}</label>
              <TextInput type={'email'} placeholder={i18n.emailAddress} />
              <label>{i18n.phone}</label>
              <TextInput type={'text'} placeholder={i18n.phone} />
              <label>{i18n.streetAddress}</label>
              <TextInput type={'text'} placeholder={i18n.streetAddress} />
              <label>{i18n.city}</label>
              <TextInput type={'text'} placeholder={i18n.city} />
              <label>{i18n.country}</label>
              <TextInput type={'text'} placeholder={i18n.country} />
              <label>{i18n.postalCode}</label>
              <TextInput type={'text'} placeholder={'0000'} />
              <Button style={{ backgroundColor: "var(--text-red)" }}>{i18n.saveChange}</Button>
            </div>
          </Col>
        </Row>
      </div>
    </AuthWrapper>
  );
};

export default Profile;
